module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "70vh"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 tabs pb-3 bold"
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "btn-group d-flex"
  }, _vm._l((_vm.tabs), function(tab, number) {
    return _c('button', {
      staticClass: "btn tertiary",
      class: {
        'bg-dark lightest': (_vm.activeTab == number)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeTab(number)
        }
      }
    }, [_vm._v(_vm._s(tab))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('top-buttons', {
    attrs: {
      "routes": _vm.getAllRoutes,
      "routeType": Number(_vm.activeTab)
    }
  })], 1)]), _vm._v(" "), (_vm.isLoadingRoutesFromApi) ? _c('div', {
    staticClass: "text-center"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box shadowless mt-3"
  }, [(_vm.activeTab == 1) ? _c('div', [_c('route-holder', {
    attrs: {
      "routes": _vm.getAllRoutes,
      "locationsList": _vm.locationsList,
      "routeType": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 2) ? _c('div', [_c('route-holder', {
    attrs: {
      "routes": _vm.getAllRoutes,
      "locationsList": _vm.locationsList,
      "routeType": 2
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 3) ? _c('div', [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.getCompanySettings.settingsPresets) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "darker fs-small font-weight-600"
  }, [_vm._v("Type a message to users know what to do for custom pickups.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCompanySettings.settingsPresets.customRouteNote),
      expression: "getCompanySettings.settingsPresets.customRouteNote"
    }],
    staticClass: "mt-2 bg-lighter",
    domProps: {
      "value": (_vm.getCompanySettings.settingsPresets.customRouteNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getCompanySettings.settingsPresets, "customRouteNote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2 w-100 d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.saveCustomMessage
    }
  }, [_vm._v("Save")])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center dark fs-large p-3 font-weight-600"
  }, [_vm._v("\n                            Loading\n                        ")])])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfcf994"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/transports/Transports.vue
// module id = 2626
// module chunks = 0